;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './PaginationDots.module.scss';

const PaginationDots = ({
    count,
    activeIndex,
    onSelect,
    label = 'slide',
    pill = false,
    className,
}) => {
    return (
        <div className={cx(styles.root, { [styles.pill]: pill }, className)}>
            {[...Array(count)].map((_, i) => {
                const isActive = activeIndex === i;

                return (
                    <button
                        key={i}
                        type="button"
                        className={cx(styles.dot, {
                            [styles.isActive]: isActive,
                        })}
                        aria-label={`Show ${label} ${i + 1} of ${count}`}
                        aria-current={isActive ? 'true' : undefined}
                        onClick={onSelect ? () => onSelect(i) : undefined}
                    />
                );
            })}
        </div>
    );
};

PaginationDots.propTypes = {
    count: PropTypes.number.isRequired,
    activeIndex: PropTypes.number,
    onSelect: PropTypes.func,
    label: PropTypes.string,
    pill: PropTypes.bool,
    className: PropTypes.string,
};

export default PaginationDots;
